import { render } from "./Edit.vue?vue&type=template&id=1cbbd857&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=1cbbd857&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cbbd857"],['__file',"src/views/BuyersGuide/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1cbbd857"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1cbbd857', __exports__)) {
    api.reload('1cbbd857', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=1cbbd857&scoped=true", () => {
    api.rerender('1cbbd857', render)
  })

}


export default __exports__